import {
  faPhoneAlt, faUserCheck, faStickyNote, faTasks, faFileInvoice,
  faArrowRight, faUserEdit, faMicrophone, faClipboardCheck, faClipboardList,
  faShare, faExclamationCircle, faEye, faUpload, faEnvelope, faEnvelopeOpen,
  faPhone, faPhoneSlash, faEdit, faFileCircleCheck
} from '@fortawesome/free-solid-svg-icons';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

export interface ActivityTypeConfig {
    label: string;
    icon: IconDefinition;
}

// Complete list matching CUSTOM_ACTIVITY_TYPE from constants
const activityTypes: Record<string, ActivityTypeConfig> = {
    // Calls - Specific icons
    INCOMING: { label: 'Incoming Call', icon: faPhone },
    OUTGOING: { label: 'Outgoing Call', icon: faPhone },
    MISSED: { label: 'Missed Call', icon: faPhoneSlash },

    // Sharing & Viewing - Specific icons
    share: { label: 'Shared', icon: faShare },
    share_viewed: { label: 'Share Viewed', icon: faEye },
    viewed: { label: 'Viewed', icon: faEye },

    // Status & Updates
    status_updated: { label: 'Status Updated', icon: faClipboardCheck },
    label_updated: { label: 'Label Updated', icon: faClipboardList },

    // Tasks - Specific icons
    task_created: { label: 'Task Created', icon: faTasks },
    task_updated: { label: 'Task Updated', icon: faEdit },
    task_assigned: { label: 'Task Assigned', icon: faUserCheck },
    task_completed: { label: 'Task Completed', icon: faFileCircleCheck },

    // Lead Assignment
    auto_lead_assign: { label: 'Auto Lead Assigned', icon: faUserCheck },
    lead_assigned: { label: 'Lead Assigned', icon: faUserCheck },

    // Notes - Specific icons
    note_created: { label: 'Note Created', icon: faStickyNote },
    new_voice_note: { label: 'Voice Note', icon: faMicrophone },

    // Quotations - Specific icons
    quotation_created: { label: 'Quotation Created', icon: faFileInvoice },
    quotation_updated: { label: 'Quotation Updated', icon: faEdit },
    quotation_approved: { label: 'Quotation Approved', icon: faFileCircleCheck },

    // Lead Updates
    lead_copied: { label: 'Lead Copied', icon: faArrowRight },
    lead_moved: { label: 'Lead Moved', icon: faArrowRight },
    lead_details_updated: { label: 'Lead Details Updated', icon: faUserEdit },
    lead_score_update: { label: 'Lead Score Updated', icon: faClipboardCheck },

    // File & Email - Specific icons
    file_upload: { label: 'File Uploaded', icon: faUpload },
    zeptomail_open: { label: 'Email Opened', icon: faEnvelopeOpen },
};

export const getActivityTypeConfig = (type: string): ActivityTypeConfig => {
    return activityTypes[type] || { label: 'Unknown Activity', icon: faExclamationCircle };
};

export default activityTypes;